/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type {ConcreteFragment} from 'relay-runtime';
export type SbRespNullSearchResults_viewer = {|
  +isShopByRoomEnabled: ?boolean;
  +isSbRespFollowSearchBannerEnabled: ?boolean;
|};
*/


const fragment /*: ConcreteFragment*/ = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SbRespNullSearchResults_viewer",
  "selections": [
    {
      "kind": "ScalarField",
      "alias": "isShopByRoomEnabled",
      "args": [
        {
          "kind": "Literal",
          "name": "featureName",
          "value": "SHOP_BY_ROOM",
          "type": "String!"
        }
      ],
      "name": "isEnabledByLocale",
      "storageKey": "isEnabledByLocale{\"featureName\":\"SHOP_BY_ROOM\"}"
    },
    {
      "kind": "ScalarField",
      "alias": "isSbRespFollowSearchBannerEnabled",
      "args": [
        {
          "kind": "Literal",
          "name": "featureName",
          "value": "NON_MVP_SEARCH_BROWSE",
          "type": "String!"
        }
      ],
      "name": "isEnabledByLocale",
      "storageKey": "isEnabledByLocale{\"featureName\":\"NON_MVP_SEARCH_BROWSE\"}"
    },
    {
      "kind": "FragmentSpread",
      "name": "CategoryTiles_viewer",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "SbRespFollowSearchBanner_viewer",
      "args": null
    }
  ],
  "type": "Viewer"
};

module.exports = fragment;
